import {
  getFromLocalStorage,
  removeFromLocalStorage,
  setInLocalStorage,
} from '@ui/utils/hooks/local-storage';

const AUTH_REDIRECT_URI_STORAGE_KEY = 'be.auth.redirect_uri';

export function getAuthRedirectUri(): string | null {
  return getFromLocalStorage<string>(AUTH_REDIRECT_URI_STORAGE_KEY, null);
}

export function setAuthRedirectUri(uri: string) {
  setInLocalStorage(AUTH_REDIRECT_URI_STORAGE_KEY, uri);
}

export function consumeAuthRedirectUri(): string | null {
  const uri = getAuthRedirectUri();
  if (uri) {
    removeFromLocalStorage(AUTH_REDIRECT_URI_STORAGE_KEY);
  }
  return uri;
}
